let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("dDulb")]).then(() => parcelRequire('j9j0S'));